import { Injectable } from '@angular/core';
import { createStore } from '@ngneat/elf';
import { selectEntity, upsertEntitiesById, withEntities } from '@ngneat/elf-entities';
import { createRequestsCacheOperator, updateRequestCache, withRequestsCache } from '@ngneat/elf-requests';
import { Observable } from 'rxjs';
import { FolderShareUserI } from '../models/folder-share';

interface FolderShareUserStateI {
    companyUuid: string;
    users: FolderShareUserI[];
}

const store = createStore(
    { name: 'folderShareUsers' },
    withEntities<FolderShareUserStateI, 'companyUuid'>({ idKey: 'companyUuid' }),
    withRequestsCache<`folder-share-users-${string}`>()
);

export const skipWhileFolderShareUsersCached = createRequestsCacheOperator(store);
export const CACHE_KEY_FOLDER_SHARE_USERS = 'folder-share-users';

@Injectable({ providedIn: 'root' })
export class FolderShareUserRepository {
    selectUsersByCompanyUuid$(companyUuid: string): Observable<FolderShareUserI[]> {
        return store.pipe(selectEntity(companyUuid, { pluck: 'users' }));
    }

    setUsers(companyUuid: string, users: FolderShareUserI[]): void {
        store.update(
            updateRequestCache(`${CACHE_KEY_FOLDER_SHARE_USERS}-${companyUuid}`),
            upsertEntitiesById(companyUuid, {
                creator: () => ({ companyUuid, users }),
                updater: entity => ({ ...entity, users })
            })
        );
    }

    clearCacheOfCompany(companyUuid: string): void {
        store.update(updateRequestCache(`${CACHE_KEY_FOLDER_SHARE_USERS}-${companyUuid}`, { value: 'none' }));
    }
}
